/*
 * Automaically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ArrowRightIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={19}
      fill='none'
      {...props}
    >
      <mask
        id='arrow-right_svg__a'
        width={18}
        height={19}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M0 .5h18v18H0z' />
      </mask>
      <g mask='url(#arrow-right_svg__a)'>
        <path
          fill='#B9BEC5'
          d='m10.5 14-1.05-1.088 2.663-2.662H3v-1.5h9.113L9.45 6.088 10.5 5 15 9.5 10.5 14Z'
        />
      </g>
    </svg>
  )
}
